@if (labelingSpec$ | async; as labelingSpec) {
  <div class="layout-col full">
    <h4 class="text-title-small">{{ 'labeling.item.title' | translate }}</h4>
    <app-labeling-spec-label
      name="item-label"
      [label]="labelingSpec.itemLabel"
    ></app-labeling-spec-label>
    <h4 class="text-title-small">{{ 'labeling.item.piece' | translate }}</h4>
    <app-labeling-spec-label
      name="item-piece-label"
      [label]="labelingSpec.itemPieceLabel"
    ></app-labeling-spec-label>
  </div>
}
